<template>
  <SfModal v-if="modalOpen" size="xs" :hide-close="true" @close="close">
    <template #title>
      <div class="sf-alignc sf-font-normal">
        {{ action }}
      </div>
    </template>
    <template #body>
      <div class="sf-level sf-below-3">
        {{ confirmationText }}
      </div>
    </template>

    <template #footer>
      <a class="sf-btn sf-btn-warning" @click="apply">{{ action }}</a>
      <a class="sf-btn" @click="close">{{
        I18n.t('js.global_confirmation_modal.default.cancel')
      }}</a>
    </template>
  </SfModal>
</template>

<script type="text/javascript">
import { SfLog } from '@app/adapters/logger'
import { SfModal } from '@app/shared/vue/components/sf-modal'
import SFetch from '@app/utils/sfetch'

export default {
  name: 'OverlappingPackageDeactivationModal',
  components: {
    SfModal,
  },

  data() {
    return {
      confirmationText: '',
      targetUrl: '',
      action: 'Deactivate',

      modalOpen: false,
    }
  },

  methods: {
    openModal(context) {
      this.targetUrl = context.url
      this.confirmationText = context.confirmationText

      this.modalOpen = true
    },

    close() {
      this.modalOpen = false
    },

    async apply() {
      this.modalOpen = false

      const url = new URL(this.targetUrl)

      try {
        const response = await SFetch.raw(url.toString(), { method: 'DELETE' })
        window.Turbolinks.visit(response.headers.get('Location'))
      } catch (error) {
        SfLog.warn('Failed to deactivate package', {
          extra: {
            error,
          },
        })
      }
    },
  },
}
</script>
